import { Injectable } from '@angular/core';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { MiscService } from '@app/services/http/misc.service';

@Injectable()
export class PaymentHelperService {
  constructor(
    private translatePipe: TranslatePipe,
    private miscService: MiscService,
  ) {}

  paymentError(error: any, user: any): string {
    switch (error.decline_code) {
      case 'insufficient_funds':
        // eslint-disable-next-line no-case-declarations
        const message = `Hej ${user.firstName},\n\nDin betaling på Handyhand fejlede da der ikke er nok midler på kortet eller pga. en spærregrænse.\nVi anbefaler at du overfører flere midler til kortet eller benytter et andet betalingskort.\n\nVisa og Marstercard har often en spærregrænse på kortet. Er dette tilfældet skal du kontakte din bank.\n\nDe bedste hilsner,\nTeam Handyhand`;
        this.miscService.sendSms(user.phone, message).subscribe();
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_INSUFFICIENT_FUNDS',
        );
      case 'do_not_honor':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_DO_NOT_HONOR',
        );
      case 'expired_card':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_EXPIRED_CARD',
        );
      case 'generic_decline':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_GENERIC_DECLINE',
        );
      case 'card_not_supported':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_CARD_NOT_SUPPORTED',
        );
      case 'invalid_amount':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_INVALID_AMOUNT',
        );
      case 'invalid_cvc':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_INVALID_CVC',
        );
      case 'invalid_expiry_month':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_INVALID_EXPIRY_MONTH',
        );
      case 'invalid_expiry_year':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_INVALID_EXPIRY_YEAR',
        );
      case 'invalid_number':
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED_INVALID_NUMBER',
        );
      default:
        return this.translatePipe.transform(
          'TOAST_MESSAGES.ERROR.PAYMENT_FAILED',
        );
    }
  }
}
